export const formatNumberValueToShort = (value: number | string, decimals = 1): number | string => {
	if (value > 1000000000) {
		return `${(Number(value) / 1000000000).toFixed(decimals)}G`;
	} else if (value > 1000000) {
		return `${(Number(value) / 1000000).toFixed(decimals)}M`;
	} else if (value > 1000) {
		return `${(Number(value) / 1000).toFixed(decimals)}K`;
	} else {
		return `${Number(value).toFixed(2)}`;
	}
};
